<template>
  <div class="card">
    <Form @submit="onSubmit" :validation-schema="schema">
      <div class="card-header">
        <h4 class="card-title">User | Edit - ({{ user.email }})</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <SelectInput
            :value="user.namespace"
            name="namespace"
            :options="namespaces"
            label="Namespace"
            placeholder="--- Select namespace ---"
            success-message="Good!"
          />

          <SelectInput
            :value="user.role"
            name="role"
            :options="roles"
            label="Role"
            placeholder="--- Select role ---"
            success-message="Good!"
          />

          <SelectInput
            :value="user.status"
            name="status"
            :options="statuses"
            label="Status"
            placeholder="--- Select status ---"
            success-message="Good!"
          />

          <TextInput
            :value="user.email"
            name="email"
            type="email"
            label="E-mail"
            placeholder="Your email address"
            success-message="Good!"
          />
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-xl-12">
            <div role="group" class="float-right btn-group">
              <button type="submit" class="btn btn-success btn-sm">Save</button>
            </div>
          </div>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { Form } from "vee-validate";
import * as Yup from "yup";
import {
  getUserById,
  namespaceList,
  roleList,
  statusList,
  updateUserById,
} from "../../controllers/user-contoller";
import TextInput from "../../components/TextInput";
import { useRoute, useRouter } from "vue-router";
import SelectInput from "../../components/SelectInput";

export default {
  name: "UserEdit",
  components: {
    Form,
    TextInput,
    SelectInput,
  },
  async setup() {
    const route = useRoute();
    const router = useRouter();
    const id = route.params.id;
    const { data } = await getUserById(id);
    console.log(data);
    const user = data;

    async function onSubmit(values) {
      const response = await updateUserById(id, values);
      if (response.status === 200) {
        await router.push({ name: "UserList" });
      } else {
        alert("Something went wrong");
      }
    }

    const schema = Yup.object().shape({
      role: Yup.string().required(),
      namespace: Yup.string().required(),
      status: Yup.string().required(),
      email: Yup.string().email().required(),
    });

    return {
      onSubmit,
      schema,
      user,
    };
  },
  data: () => {
    return {
      namespaces: namespaceList,
      roles: roleList,
      statuses: statusList,
    };
  },
  methods: {},
};
</script>
